import { render } from "./AlertsDialogApp.vue?vue&type=template&id=545bf668"
import script from "./AlertsDialogApp.vue?vue&type=script&lang=js"
export * from "./AlertsDialogApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__